import React from 'react'
import ForgotForm from './../../components/ui/dataEntry/forms/ForgotForm'
import './Auth.scss'

const ForgotPassword = ({ onSubmit, loginClicked }) => {
  return (
    <div className='forgot'>
      <div className='login-form-align'>
        <ForgotForm
          onLoginClick={loginClicked}
          onSubmit={onSubmit}
        />
      </div>
    </div>
  )
}

export default ForgotPassword
